module.exports = __webpack_public_path__ + "img/small_Antracyt (70).1925e3f8.png";